/* Solacely 2026 — shared variant-matching helper for the PDP option picker
   and the Quick View modal. Both consume the same product shape: an array
   of option names (`product.options`) and an array of variants where each
   variant has an `options` array of values in the same order (this is the
   shape returned by both `{{ product | json }}` and `/products/{handle}.js`). */
(function () {
  function findVariant(product, selectedValues) {
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, i) {
        return value === selectedValues[i];
      });
    });
  }

  function optionValues(product, optionIndex) {
    var seen = [];
    product.variants.forEach(function (variant) {
      var value = variant.options[optionIndex];
      if (seen.indexOf(value) === -1) seen.push(value);
    });
    return seen;
  }

  // Mirrors Shopify's own `product_option_value.available`: true if some
  // in-stock variant matches `value` at `optionIndex` together with the
  // currently selected values of every other option.
  function isValueAvailable(product, selectedValues, optionIndex, value) {
    return product.variants.some(function (variant) {
      if (!variant.available) return false;
      return variant.options.every(function (v, i) {
        return i === optionIndex ? v === value : v === selectedValues[i];
      });
    });
  }

  window.SolacelyVariantPicker = {
    findVariant: findVariant,
    optionValues: optionValues,
    isValueAvailable: isValueAvailable,
  };
})();
